export default __webpack_public_path__ + "static/media/Chat.6a840551.svg";